	<freud-select
		[placeholder]="'APPOINTMENTS.REPOSITION.SELECT.PLACEHOLDER' | translate"
		[options]="options"
		[label]="'APPOINTMENTS.REPOSITION.SELECT.LABEL' | translate"
		[filter]="false"
		[disabled]="disabled"
		[(ngModel)]="value"
		(onChange)="selectAppointment($event.value)"
		[optionLabel]="'label'"
		[optionValue]="'value'"
		[invalid]="invalid"
	></freud-select>
	
